<mat-chip-set>
  @for (filter of availableFilters; track filter) {
    <app-filter-chip (click)="onChipClick($event, filter)">
      <span data-label>{{ filter.label }}</span>
      <button class="mat-chip-remove mat-chip-trailing-icon" [attr.aria-label]="extraContextInfoForAccessibility + ' ' + filter.label" data-action>
        <mat-icon svgIcon="{{filter.icon}}"></mat-icon>
      </button>
    </app-filter-chip>
  }
</mat-chip-set>